export const PAGINATION_PER_PAGE = 10



// WEBPACK FOOTER //
// ./src/constants/paging.js